export var oneTimeSchema = {
    time: {
        display: true,
        required: true,
        disabled: false,
    },
    sendDate: {
        display: true,
        required: true,
        disabled: false,
    },
    endDate: {
        display: true,
        required: false,
        disabled: true,
    },
    dayOfWeek: {
        display: false,
    },
    dayOfMonth: {
        display: false,
    },
};
export var weeklySchema = {
    time: {
        display: true,
        required: true,
        disabled: false,
    },
    sendDate: {
        display: false,
    },
    endDate: {
        display: true,
        required: false,
        disabled: false,
    },
    dayOfWeek: {
        display: true,
        required: true,
        disabled: false,
    },
    dayOfMonth: {
        display: false,
    },
};
export var biWeeklySchema = weeklySchema;
export var monthlySchema = {
    time: {
        display: true,
        required: true,
        disabled: false,
    },
    sendDate: {
        display: false,
    },
    endDate: {
        display: true,
        required: false,
    },
    dayOfWeek: {
        display: false,
    },
    dayOfMonth: {
        display: true,
        required: true,
    },
};
export var inputSchemas = {
    'one-time': oneTimeSchema,
    weekly: weeklySchema,
    'bi-weekly': biWeeklySchema,
    monthly: monthlySchema,
};
export var timeOptions = [
    { label: '12:00 AM', value: '00:00' },
    { label: '1:00 AM', value: '01:00' },
    { label: '2:00 AM', value: '02:00' },
    { label: '3:00 AM', value: '03:00' },
    { label: '4:00 AM', value: '04:00' },
    { label: '5:00 AM', value: '05:00' },
    { label: '6:00 AM', value: '06:00' },
    { label: '7:00 AM', value: '07:00' },
    { label: '8:00 AM', value: '08:00' },
    { label: '9:00 AM', value: '09:00' },
    { label: '10:00 AM', value: '10:00' },
    { label: '11:00 AM', value: '11:00' },
    { label: '12:00 PM', value: '12:00' },
    { label: '1:00 PM', value: '13:00' },
    { label: '2:00 PM', value: '14:00' },
    { label: '3:00 PM', value: '15:00' },
    { label: '4:00 PM', value: '16:00' },
    { label: '5:00 PM', value: '17:00' },
    { label: '6:00 PM', value: '18:00' },
    { label: '7:00 PM', value: '19:00' },
    { label: '8:00 PM', value: '20:00' },
    { label: '9:00 PM', value: '21:00' },
    { label: '10:00 PM', value: '22:00' },
    { label: '11:00 PM', value: '23:00' },
];
export var dayOfWeekOptions = [
    { label: 'Sunday', value: 'SU' },
    { label: 'Monday', value: 'MO' },
    { label: 'Tuesday', value: 'TU' },
    { label: 'Wednesday', value: 'WE' },
    { label: 'Thursday', value: 'TH' },
    { label: 'Friday', value: 'FR' },
    { label: 'Saturday', value: 'SA' },
];
export var dayOfMonthOptions = [
    { label: '1st', value: '1' },
    { label: '2nd', value: '2' },
    { label: '3rd', value: '3' },
    { label: '4th', value: '4' },
    { label: '5th', value: '5' },
    { label: '6th', value: '6' },
    { label: '7th', value: '7' },
    { label: '8th', value: '8' },
    { label: '9th', value: '9' },
    { label: '10th', value: '10' },
    { label: '11th', value: '11' },
    { label: '12th', value: '12' },
    { label: '13th', value: '13' },
    { label: '14th', value: '14' },
    { label: '15th', value: '15' },
    { label: '16th', value: '16' },
    { label: '17th', value: '17' },
    { label: '18th', value: '18' },
    { label: '19th', value: '19' },
    { label: '20th', value: '20' },
    { label: '21st', value: '21' },
    { label: '22nd', value: '22' },
    { label: '23rd', value: '23' },
    { label: '24th', value: '24' },
    { label: '25th', value: '25' },
    { label: '26th', value: '26' },
    { label: '27th', value: '27' },
    { label: '28th', value: '28' },
    { label: '29th (or last day of month)', value: '29' },
    { label: '30th (or last day of month)', value: '30' },
    { label: '31st (or last day of month)', value: '31' },
];
export var CampaignSchedule;
(function (CampaignSchedule) {
    CampaignSchedule["ONE_TIME"] = "one-time";
    CampaignSchedule["WEEKLY"] = "weekly";
    CampaignSchedule["BI_WEEKLY"] = "bi-weekly";
    CampaignSchedule["MONTHLY"] = "monthly";
})(CampaignSchedule || (CampaignSchedule = {}));
export var schedulingOptions = [
    { label: 'One-time', value: CampaignSchedule.ONE_TIME },
    { label: 'Weekly', value: CampaignSchedule.WEEKLY },
    { label: 'Every 2 weeks', value: CampaignSchedule.BI_WEEKLY },
    { label: 'Monthly', value: CampaignSchedule.MONTHLY },
];
export var getActiveOption = function (value, options) {
    return options.find(function (option) { return option.value === value; });
};
